var chunkMapping = {
	"2080": [
		2266
	],
	"3034": [
		3034
	],
	"8594": [
		8594
	]
};
var idToExternalAndNameMapping = {
	"2266": [
		"default",
		"./useCurrentAccountContracts",
		6435
	],
	"3034": [
		"default",
		"./useBenefitUsages",
		6435
	],
	"8594": [
		"default",
		"./HeaderHomeNotification",
		5277
	]
};
var idToRemoteMap = {
	"2266": [
		{
			"externalType": "script",
			"name": "contract",
			"externalModuleId": 6435
		}
	],
	"3034": [
		{
			"externalType": "script",
			"name": "contract",
			"externalModuleId": 6435
		}
	],
	"8594": [
		{
			"externalType": "script",
			"name": "notification",
			"externalModuleId": 5277
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}